var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonFieldSelect',_vm._b({staticClass:"mb-n3",attrs:{"items":_vm.items,"clearable":true,"dense":"","label":_vm.label,"itemText":"text","itemValue":"value"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'CommonFieldSelect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }